module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["IBS is complex and hard."])},
        "subtitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The data-driven IBS management platform for doctors."])},
        "beta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["✨ Join The Beta ✨"])}
      },
      "fr": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le SII est complexe et difficile."])},
        "subtitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["La plateforme de gestion du SII pour les médecins, basée sur les données patients."])},
        "beta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["✨ Rejoignez la Beta ✨"])}
      }
    }
  })
  Component.options.__i18nBridge = Component.options.__i18nBridge || []
  Component.options.__i18nBridge.push('{"en":{"title":"IBS is complex and hard.","subtitle":"The data-driven IBS management platform for doctors.","beta":"✨ Join The Beta ✨"},"fr":{"title":"Le SII est complexe et difficile.","subtitle":"La plateforme de gestion du SII pour les médecins, basée sur les données patients.","beta":"✨ Rejoignez la Beta ✨"}}')
  delete Component.options._Ctor
  
}
